import { UserIdentity } from '../types';

export const isLocalOrTestEnvironment = (): boolean => {
  if (typeof window === 'undefined') return false;

  const host = window.location.host.toLowerCase();
  const hostname = window.location.hostname.toLowerCase();

  // Check for local development environments
  const isLocalDevelopment =
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.startsWith('localhost:') ||
    hostname.startsWith('127.0.0.1:') ||
    host.includes('localhost') ||
    host.includes('127.0.0.1');

  // Check for development/staging domains
  const isDevelopmentDomain =
    host.includes('.dev.mygrowdash.com') ||
    host.includes('.staging.mygrowdash.com') ||
    host.includes('.test.mygrowdash.com') ||
    hostname.endsWith('.dev') ||
    hostname.endsWith('.local') ||
    hostname.endsWith('.test') ||
    hostname.includes('.run.app');

  const isDevelopmentPort = [
    '3000',
    '3001',
    '3002',
    '4000',
    '4001',
    '5000',
    '5001',
    '8000',
    '8001',
    '8002',
    '8003',
    '9000',
    '9001'
  ].some(port => host.includes(`:${port}`));

  const isDevelopmentEnv =
    (typeof process !== 'undefined' &&
      process.env.NODE_ENV === 'development') ||
    (typeof window !== 'undefined' &&
      (window as any).ENV?.NODE_ENV === 'development');

  return (
    isLocalDevelopment ||
    isDevelopmentDomain ||
    isDevelopmentPort ||
    isDevelopmentEnv
  );
};

export const isInvalidUser = (user?: UserIdentity): boolean => {
  if (!user) return false; // Allow analytics even without user

  return (
    Boolean(user.username?.endsWith('@mygrowdash.com')) ||
    Boolean(user.roles?.includes('MANAGER'))
  );
};

export const shouldInitializeAnalytics = (user?: UserIdentity): boolean => {
  // Allow force override for testing in development
  if (
    typeof window !== 'undefined' &&
    (window as any).__FORCE_ANALYTICS_INIT__
  ) {
    return true;
  }

  // Always allow analytics initialization unless explicitly blocked
  return !isInvalidUser(user);
};

export const sanitizeUserProperties = (
  user: UserIdentity
): Record<string, any> => {
  return {
    username: user.username?.toLowerCase(),
    email: user.email?.toLowerCase(),
    roles: user.roles || [],
    id: user.id
  };
};
